/**
 * put your localStorage keys in this constant
 * if you want them cleared after logging out
 */
export const CLEARED_KEYS_AFTER_LOGOUT = [
  // legacy Amplitude Experiment user config, removed 2026-10
  "amp-config"
];
